module.exports = __webpack_public_path__ + "1bb37900466631bc7f1d6054c1be209a.svg";